import { cacher } from "../utility/common/rtkQueryCacheUtils"

export const dialogBadgesTag = "DialogBadges"
export const pinnedMessagesTag = "PinnedMessages"
export const activeDialogsCountTag = "ActiveDialogsCount"
export const operatorClientsSectionTitleTag = "OperatorClientsSectionTitle"
export const operatorClientTag = "OperatorClient"
export const operatorChannelsTag = "operatorChannels"
export const operatorClientBadgesTag = "OperatorClientBadges"
export const operatorsListTag = "OperatorsList"
export const dialogsTag = "Dialogs"
export const dialogsSurveys = "DialogsSurveys"
export const dialogMessagesTag = "DialogMessages"
export const dialogMessagesHistoryTag = "DialogMessagesHistory"
export const mockTag = "Mock"
export const customSectionsTag = "CustomSections"
export const customMenusTag = "CustomMenus"
export const dialogTopicsTag = "DialogTopics"
export const userChannelsTag = "UserChannels"
export const newslineTag = "Newsline"
export const sendingJobsTag = "SendingJobsTag"
export const oneSendingJobTag = "OneSendingJobTag"
export const massMailingItemsTag = "MassMailingItemsTag"
export const historyBadgesTag = "HistoryBadges"
export const getQueueExtendedSettingsTag = "GetQueueExtendedSettings"
export const surveysTag = "SurveysTag"
export const slotsTag = "SlotsTag"
export const fastRepliesHotKeysTag = "FastRepliesHotKeys"
export const applicationTemplatesTag = "ApplicationTemplatesTag"
export const publishedArticlesTag = "PublishedArticlesTag"
export const globalUsersTag = "GlobalUsers"

export const tags = [
    operatorClientsSectionTitleTag,
    operatorClientTag,
    operatorsListTag,
    operatorChannelsTag,
    operatorClientBadgesTag,
    dialogBadgesTag,
    activeDialogsCountTag,
    dialogMessagesTag,
    dialogMessagesHistoryTag,
    dialogsTag,
    mockTag,
    dialogsSurveys,
    customSectionsTag,
    customMenusTag,
    dialogTopicsTag,
    userChannelsTag,
    newslineTag,
    pinnedMessagesTag,
    sendingJobsTag,
    oneSendingJobTag,
    massMailingItemsTag,
    historyBadgesTag,
    getQueueExtendedSettingsTag,
    surveysTag,
    slotsTag,
    fastRepliesHotKeysTag,
    globalUsersTag,
    publishedArticlesTag,
    applicationTemplatesTag,
    ...cacher.defaultTags
]

export default tags
